import script from "./web-artist-list.vue?vue&type=script&setup=true&lang=js"
export * from "./web-artist-list.vue?vue&type=script&setup=true&lang=js"

import "./web-artist-list.vue?vue&type=style&index=0&id=22d42e15&lang=scss"

const __exports__ = script;

export default __exports__